












import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Stream } from "stream";


@Component({ name: "l-navigation" })
export default class LNavigationComponent extends Vue {
  @Prop({ default: false, type: Boolean })
  visible: boolean;

  @Prop({ default: "Навигационная панель", type: String })
  header: string;

  panelVisible = this.visible;
  innerHeader = this.header;
  mounted(){
    // const panel =this.$slots.default
    // console.log(panel)
  }

  toggole() {
    this.panelVisible = !this.panelVisible;
  }
  
  @Watch ("visible")
   xx(){
    this.toggole()
  }
  

}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/l-navigation.vue